import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { ADDENDUM_IN_PROGRESS } from '../../../../../constants/reports';
import { formatDate } from '../../../../../utils/formatters';

const FutureDeedReportRow = ({ rowData, id, nestedColumnsNumber }) => {
  return (
    <tr key={id} className="table-body-tr future-deep-tr">
      <td width="50px" align="center" className="valign-middle">
        {id}
      </td>
      <td className="valign-middle td-break-f">
        <div className="mb-1 display-block">{rowData?.purchaserName}</div>
        <div className="unit-no">{rowData?.onePortalId}</div>
      </td>
      {[...Array(nestedColumnsNumber)].map((_col, column) => {
        return (
          <td key={column} className="p-0 tb-next td-next-1">
            {rowData?.businessUnit?.map((item, itemIndex) => {
              return (
                <table key={itemIndex} className="inner-table">
                  <tbody>
                    {item?.unitDetails.map((subItem, subIndex) => {
                      return (
                        <>
                          {column === 0 && (
                            <tr>
                              <td className="detail-td">
                                {subIndex === 0 && (
                                  <div className="mb-1 display-block detail-div">
                                    {`${item?.businessUnitType}(${item?.unitDetails?.length})`}
                                  </div>
                                )}
                                <span className="unit-no">{subItem?.contractNumber}</span>
                                {subItem?.addendumStatus === ADDENDUM_IN_PROGRESS && (
                                  <p className="addendum-note">Note: Addendum In Progress</p>
                                )}
                              </td>
                            </tr>
                          )}
                          {column === 2 && (
                            <tr className="tr-next">
                              <td>{formatDate(subItem?.dueDate)}</td>
                            </tr>
                          )}
                          {column === 3 && (
                            <tr className="tr-next">
                              <td>{subItem?.counselorName || '-'}</td>
                            </tr>
                          )}
                          {column === 1 && (
                            <tr className="tr-next">
                              <td>{getPrice(subItem?.dueAmount) || '-'}</td>
                            </tr>
                          )}
                          {column === 4 && (
                            <tr className="tr-next">
                              <td>{subItem?.managerName || '-'}</td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              );
            })}
          </td>
        );
      })}
    </tr>
  );
};

FutureDeedReportRow.propTypes = {
  rowData: PropTypes.shape({
    businessUnit: PropTypes.shape([
      {
        businessUnitType: PropTypes.string,
        unitDetails: PropTypes.shape([
          {
            contractNumber: PropTypes.string,
            dueDate: PropTypes.string,
            counselorName: PropTypes.string,
            dueAmount: PropTypes.number,
            managerName: PropTypes.string,
          },
        ]),
      },
    ]),
  }).isRequired,
  id: PropTypes.number.isRequired,
  nestedColumnsNumber: PropTypes.number.isRequired,
};

export default FutureDeedReportRow;
